import { Link } from "react-router-dom";

/* ICONS */
import { MdContactSupport } from "react-icons/md";
import { FaUserTie } from "react-icons/fa";
import { BiSolidCategory } from "react-icons/bi";
import { HiNewspaper } from "react-icons/hi";

/* ASSETS */
import Logo from "../../assets/images/district-58-logo.webp";

const Sidebar = () => {
  var pathname = window.location.pathname;

  return (
    <section className="h-screen w-sidebar bg-black transition-all duration-300 ease-linear">
      {/* HEADER */}
      <div className="border-b border-white border-opacity-20 p-5 flex items-center">
        <div className="w-16 h-16 rounded-md bg-black p-1">
          <img
            src={Logo}
            className="w-16 object-contain"
            alt="Farmers Insurance"
          />
        </div>
      </div>

      {/* NAVIGATION OPTIONS */}
      <div className="h-[85vh] flex flex-col justify-between">
        <div className="py-5 px-2">
          {/* MANAGE QUERIES */}
          <div className="mt-0">
            <p className="pl-3 text-xs font-ibm-regular text-white/60">
              MANAGE QUERIES
            </p>
            <div className="mt-3">
              {/* CONTACT US */}
              <Link
                to="/contact-us"
                className={`w-full group flex items-center gap-3 ${
                  pathname === "/contact-us"
                    ? "bg-white/10 text-white"
                    : "text-sidebarText"
                }  rounded-md py-2.5 px-3`}
              >
                <MdContactSupport className="w-5 h-5 transition-all duration-300 ease-in-out" />
                <p className="text-base font-ibm-regular leading-none transition-all duration-300 ease-in-out">
                  Contact Us
                </p>
              </Link>

              {/* CAREER LEADS */}
              <Link
                to="/career-leads"
                className={`mt-3 w-full group flex items-center gap-3 ${
                  pathname === "/career-leads"
                    ? "bg-white/10 text-white"
                    : "text-sidebarText"
                }  rounded-md py-2.5 px-3`}
              >
                <FaUserTie className="w-5 h-5 transition-all duration-300 ease-in-out" />
                <p className="text-base font-ibm-regular leading-none transition-all duration-300 ease-in-out">
                  Career Leads
                </p>
              </Link>
            </div>
          </div>

          {/* BLOGS */}
          <div className="mt-8">
            <p className="pl-3 text-xs font-ibm-regular text-white/60">BLOGS</p>
            <div className="mt-3">
              {/* CATEGORIES */}
              <Link
                to="/categories"
                className={`w-full group flex items-center gap-3 ${
                  pathname === "/categories"
                    ? "bg-white/10 text-white"
                    : "text-sidebarText"
                }  rounded-md py-2.5 px-3`}
              >
                <BiSolidCategory className="w-5 h-5 transition-all duration-300 ease-in-out" />
                <p className="text-base font-ibm-regular leading-none transition-all duration-300 ease-in-out">
                  Categories
                </p>
              </Link>

              {/* BLOGS */}
              <Link
                to="/blogs"
                className={`mt-3 w-full group flex items-center gap-3 ${
                  pathname === "/blogs"
                    ? "bg-white/10 text-white"
                    : "text-sidebarText"
                }  rounded-md py-2.5 px-3`}
              >
                <HiNewspaper className="w-5 h-5 transition-all duration-300 ease-in-out" />
                <p className="text-base font-ibm-regular leading-none transition-all duration-300 ease-in-out">
                  Blogs
                </p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
